@if (conceptFields && conceptFields.length) {
  <div class="md-table admin-concept-concepts-list admin-scroll-layout">
    <table
      [attr.height]="height"
      mat-table
      matSort
      [dataSource]="conceptsContainer.conceptDataSource"
    >
      @for (field of conceptFields; track $index) {
        <ng-container
          [matColumnDef]="field.name"
          [sticky]="(isLargeScreen && field.name === 'select') || (isLargeScreen && field.name === nameField)"
          [stickyEnd]="(isLargeScreen && field.name === 'action')"
        >
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header=""
            [disabled]="field.sortable === false"
          >
            @if (field.type === 'select') {
              <mat-checkbox
                class="admin-concept-concepts-list__checkbox"
                [(ngModel)]="conceptsContainer.allSelected"
                (ngModelChange)="selectAll()"
                [indeterminate]="!conceptsContainer.allSelected && conceptsContainer.selected.length > 0">
              </mat-checkbox>
            }

            <span [ngClass]="{'admin-table-select-all-name': field.type === 'select'}">
              {{field.title | translate}}
            </span>
          </th>

          <td mat-cell *matCellDef="let row; let i = index">
            @if (field.type === 'value') {
              <ng-container>
                <span>
                  {{row[field.name]}}
                </span>
              </ng-container>
            }
            @else {
              <app-admin-list-item-special-value
                class="concept-special-value"
                [ngClass]="{'has-link': conceptsContainer.showLinkToObject}"
                [value]="row[field.name]"
                [concept]="row"
                [conceptField]="field"
                [conceptsContainer]="conceptsContainer"
                [index]="i"
                (conceptOpened)="openConcept($event)"
                (updateConceptList)="setReloadConcepts(false)"
              ></app-admin-list-item-special-value>
            }
          </td>
        </ng-container>
      }

      <tr mat-header-row *matHeaderRowDef="displayedCol; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedCol" class="concept-rows view-hover-color"></tr>
    </table>
  </div>
}

<div class="admin-action-toolbar">
    <app-admin-list-action-toolbar
      [conceptsContainer]="conceptsContainer"
      (updateConceptList)="setReloadConcepts(false)"
    ></app-admin-list-action-toolbar>

    <mat-paginator
      [pageSizeOptions]="[20, 50, 100, 1000]"
      [pageSize]="20"
      (page)="changePage()"
      showFirstLastButtons
    ></mat-paginator>
</div>

